(function(){
  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('es-visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('[data-es-animate],[data-es-stagger]').forEach(function(el){
    obs.observe(el);
  });
  var bar = document.getElementById('es-sticky-wa');
  if (bar) {
    var shown = false;
    window.addEventListener('scroll', function(){
      if (window.scrollY > 300 && !shown) {
        bar.classList.add('es-sticky-wa--visible');
        shown = true;
      }
    }, { passive: true });
  }
})();